/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { AdminCBQExamListItem } from "./GetAdminCBQExams";
import { CBQScenarioDTO } from "./InitCBQScenario";

// Detail may inline its scenarios; the edit page falls back to the scenarios
// endpoint when it doesn't.
export interface AdminCBQExamDetail extends AdminCBQExamListItem {
  scenarios?: CBQScenarioDTO[] | null;
}

type GetAdminCBQExamResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: AdminCBQExamDetail;
};

// GET /admin/cbq/exams/:cbqExamId
export const GetAdminCBQExam = async (
  examId: string
): Promise<GetAdminCBQExamResponse> => {
  try {
    const response = await axios.get(`/admin/cbq/exams/${examId}`);
    return { data: response.data?.data ?? response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data?.message,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
